import { useState } from 'react';
import { AlertTriangle, ChevronDown, ChevronRight } from 'lucide-react';
import { palette } from '../../styles/tokens';
import type { Conflict } from './config';

interface Props {
  conflicts: Conflict[];
}

export function ConflictBanner({ conflicts }: Props) {
  const [expanded, setExpanded] = useState(false);

  if (conflicts.length === 0) return null;

  const errors = conflicts.filter(c => c.severity === 'error');
  const warnings = conflicts.filter(c => c.severity === 'warning');

  return (
    <div style={{ marginBottom: 12, borderRadius: 10, overflow: 'hidden', border: `1px solid ${errors.length > 0 ? palette.red + '40' : palette.amber + '40'}`, background: errors.length > 0 ? palette.redWash : palette.amberWash }}>
      <button onClick={() => setExpanded(!expanded)} style={{
        display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '10px 14px',
        border: 'none', background: 'transparent', cursor: 'pointer', fontFamily: 'inherit',
      }}>
        <AlertTriangle size={14} color={errors.length > 0 ? palette.red : palette.amber} />
        <span style={{ fontSize: 13, fontWeight: 600, color: palette.g800 }}>
          {conflicts.length} conflict{conflicts.length !== 1 ? 's' : ''} detected
        </span>
        {errors.length > 0 && <span style={{ fontSize: 11, color: palette.red, fontWeight: 600 }}>{errors.length} error{errors.length !== 1 ? 's' : ''}</span>}
        {warnings.length > 0 && <span style={{ fontSize: 11, color: palette.amber, fontWeight: 600 }}>{warnings.length} warning{warnings.length !== 1 ? 's' : ''}</span>}
        <span style={{ flex: 1 }} />
        {expanded ? <ChevronDown size={14} color={palette.g500} /> : <ChevronRight size={14} color={palette.g500} />}
      </button>

      {expanded && (
        <div style={{ padding: '0 14px 12px' }}>
          {conflicts.map((c, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderTop: i > 0 ? `1px solid ${palette.g200}30` : 'none', fontSize: 12 }}>
              <span style={{ width: 6, height: 6, borderRadius: 3, background: c.severity === 'error' ? palette.red : palette.amber, flexShrink: 0 }} />
              <span style={{ color: palette.g700, flex: 1 }}>{c.description}</span>
              <span style={{ fontSize: 10, color: palette.g400, textTransform: 'capitalize' }}>{c.type.replace(/_/g, ' ')}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
